export default "__VITE_ASSET__fc44cec4__"